<template>
  <v-container class="grey lighten-5" fluid>
    <div class="pa-3 display-1" id="title">
      納品明細書・報告書一覧
    </div>
  <v-card class="py-5">
    <span class="title px-3 my-3">納品明細書・報告書一覧</span>
    <span class="caption px-3">ダウンロード可能な納品明細書・報告書の一覧です。</span>
    <v-row>
      <v-col cols="3">
        <div class="px-3">
          <v-text-field
            v-model="orderNumberFilter"
            prepend-inner-icon="mdi-magnify"
            placeholder="受注番号で絞り込み"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="px-3">
          <v-text-field
            v-model="sampleNumberFilter"
            prepend-inner-icon="mdi-magnify"
            placeholder="依頼番号で絞り込み"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="px-3">
        <v-text-field
          v-model="searchText"
          prepend-inner-icon="mdi-magnify"
          placeholder="ファイル名で検索"
        ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          ref="dataTable"
          :headers="deliverablesHeaders"
          :items="filteredDeliverables"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          :loading="loading"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="データがありません。"                    
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="showDeliverableDetail"
          id="row-pointer"
        >
          <template v-slot:[`item.Type`]="{ item }">
            <v-chip small :color="getTypeColor(item.Type)" class="white--text type-chip">
              {{ getTypeDisplayName(item.Type) }}
            </v-chip>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <v-chip small :color="getStatusColor(item.Status)" class="white--text">
              {{ item.Status }}
            </v-chip>
          </template>
          <template v-slot:[`item.FileName`]="{ item }">
            {{ getFileNameOnly(item.FileName) }}
          </template>
          <template v-slot:[`item.DownloadDeadline`]="{ item }">
            {{ formatDateOnly(item.DownloadDeadline) }}
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ formatDateOnly(item.createdAt) }}
          </template>
          <template v-slot:[`item.DownloadCount`]="{ item }">
            {{ item.DownloadCount || 0 }}回
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" md='10' sm='12'>
        <v-pagination
          v-model="page"
          :total-visible="totalVisible"
          :length="pageCount"
          color="amber black--text"
          light 
          circle
        >
        </v-pagination>
      </v-col>
      <!-- <v-col cols="2" md='2' sm='4'>
        <v-text-field
          :value="itemsPerPage"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-text-field>
      </v-col> -->
      <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>
  </v-card>
  
  <!-- 詳細ダイアログ -->
  <v-dialog v-model="isDeliverableDetailDialog" max-width="70%">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        <span class="ml-2">納品明細書・報告書詳細<span v-if="selectedDeliverable" class="body-2">（{{ selectedDeliverable.id }}）</span></span>
      </v-card-title>
      <v-card-text v-if="selectedDeliverable">
        <v-row dense v-if="selectedDeliverable.Type === '納品書' || selectedDeliverable.Type === '納品書その他'">
          <v-col cols="6">
            <span class="caption">受注番号</span><br>
            <span class="body-1">{{ selectedDeliverable.OrderNumber }}</span>
          </v-col>
          <v-col cols="6">
            <span class="caption">タイプ</span><br>
            <v-chip small :color="getTypeColor(selectedDeliverable.Type)" class="white--text">
              {{ getTypeDisplayName(selectedDeliverable.Type) }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row dense v-else>
          <v-col cols="3">
            <span class="caption">受注番号</span><br>
            <span class="body-1">{{ selectedDeliverable.OrderNumber }}</span>
          </v-col>
          <v-col cols="3">
            <span class="caption">依頼番号</span><br>
            <span class="body-1">{{ selectedDeliverable.SampleNumber }}</span>
          </v-col>
          <v-col cols="3">
            <span class="caption">サンプルID</span><br>
            <span class="body-1">{{ selectedDeliverable.SampleID || '-' }}</span>
          </v-col>
          <v-col cols="3">
            <span class="caption">タイプ</span><br>
            <v-chip small :color="getTypeColor(selectedDeliverable.Type)" class="white--text">
              {{ getTypeDisplayName(selectedDeliverable.Type) }}
            </v-chip>
          </v-col>
        </v-row>
        <v-divider class="my-3"></v-divider>
        <v-row dense>
          <v-col cols="6">
            <span class="caption">登録日</span><br>
            <span class="body-1">{{ formatDateOnly(selectedDeliverable.createdAt) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="caption">ダウンロード期限</span><br>
            <span class="body-1">{{ formatDateOnly(selectedDeliverable.DownloadDeadline) }}</span>
          </v-col>
        </v-row>
        <v-divider class="my-3"></v-divider>
        <v-row dense v-if="selectedDeliverable.Type !== '納品書' && selectedDeliverable.Type !== '納品書その他'">
          <v-col cols="12">
            <span class="caption">サンプル名</span><br>
            <span class="body-1">{{ selectedDeliverable.SampleName || '-' }}</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <span class="caption">ファイル名</span><br>
            <span class="body-1">{{ getFileNameOnly(selectedDeliverable.FileName) }}</span>
          </v-col>
            <v-col cols="6" v-if="selectedDeliverable.Type==='報告書'">
              <span class="caption">報告書番号</span><br>
              <span class="body-1">{{ getFileNameOnly(selectedDeliverable.ReportNumber) }}({{ getFileNameOnly(selectedDeliverable.ReportVersion) }})</span>
            </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="4">
            <span class="caption">ダウンロード回数</span><br>
            <span class="body-1">{{ selectedDeliverable.DownloadCount }}回</span>
          </v-col>
          <v-col cols="4">
            <span class="caption">ダウンロード日時</span><br>
            <span class="body-1">{{ selectedDeliverable.DownloadAt ? formatDateToJST(selectedDeliverable.DownloadAt) : '-' }}</span>
          </v-col>
          <v-col cols="4">
            <span class="caption">ダウンロード担当者</span><br>
            <span class="body-1">{{ selectedDeliverable.DownloadUser || '-' }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn 
            color="amber" 
            rounded 
            @click="downloadFile" 
            class="ma-4"
            :disabled="isDownloadExpired"
          >
            <v-icon class="mr-2">mdi-download</v-icon>
            ダウンロード
          </v-btn>
          <div v-if="isDownloadExpired" class="red--text caption ml-4">
            ダウンロード期限を過ぎています
          </div>
        </div>
        <v-btn color="amber" rounded @click="showDownloadHistory" class="ma-4">
          <v-icon class="mr-2">mdi-history</v-icon>
          ダウンロード履歴
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="amber darken-1" rounded @click="isDeliverableDetailDialog=false" class="ma-4">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- ダウンロード履歴ダイアログ -->
  <v-dialog v-model="isDownloadHistoryDialog" max-width="70%">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        <span class="ml-2">ダウンロード履歴</span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="downloadHistoryHeaders"
          :items="downloadHistory"
          :loading="downloadHistoryLoading"
          loading-text="読込中"
          no-data-text="ダウンロード履歴がありません。"
          class="elevation-1"
          :sort-by="['DownloadAt']"
          :sort-desc="[true]"
          :page.sync="historyPage"
          :items-per-page="historyItemsPerPage"
          hide-default-footer
          @page-count="historyPageCount = $event"
        >
          <template v-slot:[`item.DownloadAt`]="{ item }">
            {{ formatDateToJST(item.DownloadAt) }}
          </template>
        </v-data-table>
        
        <v-row justify="center" dense class="mt-3">
          <v-col cols="10">
            <v-pagination
              v-model="historyPage"
              :total-visible="totalVisible"
              :length="historyPageCount"
              color="amber darken-1 black--text"
              light
              circle
            ></v-pagination>
          </v-col>
          <v-col cols="2">
            <v-select
              :value="historyItemsPerPage"
              :items="itemsPerPageList"
              label="1ページの行数"
              @input="historyItemsPerPage = $event"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="orange" rounded @click="isDownloadHistoryDialog=false" class="ma-4">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from "aws-amplify"
import { deliverablesByOffice, downloadHistoryByDeliverables } from '../graphql/queries'
import { createDownLoadHistory, updateDeliverables } from '../graphql/mutations'

export default {
  name: 'DeliverableList',
  head: {
    title: { inner: '納品明細書・報告書一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      totalVisible: 7,
      itemsPerPage: 10,
      itemsPerPageList: [ 5,10,30 ],
      loading: false,
      deliverables: [],
      selectedDeliverable: null,
      isDeliverableDetailDialog: false,
      isDownloadHistoryDialog: false,
      downloadHistory: [],
      downloadHistoryLoading: false,
      orderNumberFilter: '',
      sampleNumberFilter: '',
      searchText: '',
      deliverablesHeaders: [
        {
          text: 'タイプ',
          value: 'Type',
          class: "grey darken-2 white--text",
          width: '11%'
        },
        {
          text: '受注番号',
          value: 'OrderNumber',
          class: "grey darken-2 white--text",
          width: '10%'
        },
        {
          text: '依頼番号',
          value: 'SampleNumber',
          class: "grey darken-2 white--text",
          width: '10%'
        },
        {
          text: 'サンプル名',
          value: 'SampleName',
          class: "grey darken-2 white--text",
          width: '22%'
        },
        {
          text: 'ファイル名',
          value: 'FileName',
          class: "grey darken-2 white--text",
          width: '20%'
        },
        {
          text: '登録日',
          value: 'createdAt',
          class: "grey darken-2 white--text",
          width: '10%'
        },
        {
          text: 'ダウンロード期限',
          value: 'DownloadDeadline',
          class: "grey darken-2 white--text",
          width: '12%'
        },
        {
          text: 'DL回数',
          value: 'DownloadCount',
          class: "grey darken-2 white--text",
          width: '8%'
        }
      ],
      typeOptions: [
        { value: 'all', text: 'すべて' },
        { value: '納品書', text: '納品明細書' },
        { value: '報告書', text: '報告書' },
        { value: '速報報告書', text: '速報報告書' }
      ],
      statusOptions: [
        { value: 'all', text: 'すべて' },
        { value: 'READY', text: 'READY' },
        { value: 'PENDING', text: 'PENDING' },
        { value: 'STOP', text: 'STOP' }
      ],
      downloadHistoryHeaders: [
        {
          text: 'ダウンロード日時',
          value: 'DownloadAt',
          class: "grey darken-2 white--text",
          width: '20%'
        },
        {
          text: 'ユーザー',
          value: 'DownloadUser',
          class: "grey darken-2 white--text",
          width: '80%'
        },
      ],
      historyPage: 1,
      historyPageCount: 0,
      historyItemsPerPage: 10
    }
  },
  mounted: async function () {
    this.loading = true
    
    try {
      const result = await API.graphql(graphqlOperation(deliverablesByOffice, {
        OfficeID: this.$store.state.operatingOffice.OfficeID,
        limit: 999
      }))
      this.deliverables = result.data.deliverablesByOffice.items.filter(item => item.Status === 'READY')
      console.log('Deliverables loaded:', this.deliverables.length)
    } catch (err) {
      console.error('Error fetching deliverables:', err)
    }
    
    this.loading = false
  },
  watch: {
    page() {
      this.$nextTick(() => {
        const tableWrapper = this.$refs.dataTable.$el.querySelector('.v-data-table__wrapper')
        if (tableWrapper) {
          tableWrapper.scrollTop = 0
        }
      })
    }
  },
  methods: {
    getTypeDisplayName(type) {
      switch(type) {
        case '納品書': return '納品明細書'
        case '納品書その他': return '納品明細書その他'
        default: return type
      }
    },

    getTypeColor(type) {
      switch(type) {
        case '納品書': return 'blue'
        case '納品書その他': return 'blue'
        case '報告書': return 'green'
        case '報告書その他': return 'green'
        case '速報報告書': return 'orange'
        default: return 'grey'
      }
    },

    getStatusColor(status) {
      switch(status) {
        case 'READY': return 'green'
        case 'PENDING': return 'orange'
        case 'STOP': return 'red'
        default: return 'grey'
      }
    },

    getFileNameOnly(filePath) {
      if (!filePath) return ''
      return filePath.split('/').pop()
    },

    showDeliverableDetail(item) {
      this.selectedDeliverable = item
      this.isDeliverableDetailDialog = true
    },

    downloadDeliverableFile: async function(deliverable) {
      if (!deliverable || !deliverable.FileName) {
        console.error('No file selected for download')
        return
      }

      try {
        const filePath = 'deliverable' + deliverable.FileName
        
        const signedURL = await Storage.get(filePath, {
          level: 'public',
          expires: 180,
          contentType: 'application/octet-stream'
        })
        
        const link = document.createElement('a')
        link.href = signedURL
        link.download = this.getFileNameOnly(deliverable.FileName)
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // システム管理者以外がダウンロードした場合のみ、ダウンロード履歴を記録
        if(!this.isSystemAdmin) {
          const currentDateTime = new Date().toISOString()
          const currentUser = this.$store.state.employee?.Name || 'unknown'
        
          // Deliverablesレコードを更新
          const updateInput = {
            id: deliverable.id,
            DownloadCount: (deliverable.DownloadCount || 0) + 1
          }
        
          // 初回ダウンロードの場合はDownloadAtとDownloadUserも更新
          if (!deliverable.DownloadAt) {
            updateInput.DownloadAt = currentDateTime
            updateInput.DownloadUser = currentUser
          }
        
          await API.graphql(graphqlOperation(updateDeliverables, {
            input: updateInput
          }))
        
          // DownLoadHistoryレコードを作成
          const downloadHistory = {
            DeliverablesID: deliverable.id,
            DownloadAt: currentDateTime,
            DownloadUser: currentUser,
            Type: 'WEB_DOWNLOAD'
          }
        
          await API.graphql(graphqlOperation(createDownLoadHistory, {
            input: downloadHistory
          }))
        
          console.log('File download initiated successfully')
        }
      } catch (err) {
        console.error('Error downloading file:', err)
      }
    },

    downloadFile: async function() {
      await this.downloadDeliverableFile(this.selectedDeliverable)
    },

    showDownloadHistory: async function() {
      if (!this.selectedDeliverable) {
        console.error('No deliverable selected')
        return
      }
      
      this.isDownloadHistoryDialog = true
      this.downloadHistoryLoading = true
      
      try {
        const result = await API.graphql(graphqlOperation(downloadHistoryByDeliverables, {
          DeliverablesID: this.selectedDeliverable.id
        }))
        // DownloadAtの昇順でソート
        this.downloadHistory = result.data.downloadHistoryByDeliverables.items.sort((a, b) => 
          new Date(a.DownloadAt) - new Date(b.DownloadAt)
        )
        console.log('Download history loaded:', this.downloadHistory.length)
      } catch (err) {
        console.error('Error fetching download history:', err)
      }
      
      this.downloadHistoryLoading = false
    },

    formatDateToJST: function(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    formatDateOnly: function(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ja-JP', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '年').replace(/\//g, '月') + '日'
    }
  },
  computed: {
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    filteredDeliverables() {
      let filtered = this.deliverables
      
      // 受注番号フィルター
      if (this.orderNumberFilter) {
        filtered = filtered.filter(item => 
          item.OrderNumber && item.OrderNumber.toLowerCase().includes(this.orderNumberFilter.toLowerCase())
        )
      }
      
      // 依頼番号フィルター
      if (this.sampleNumberFilter) {
        filtered = filtered.filter(item => 
          item.SampleNumber && item.SampleNumber.toLowerCase().includes(this.sampleNumberFilter.toLowerCase())
        )
      }
      
      // ファイル名検索
      if (this.searchText) {
        filtered = filtered.filter(item => 
          this.getFileNameOnly(item.FileName).toLowerCase().includes(this.searchText.toLowerCase())
        )
      }
      
      return filtered
    },
    isDownloadExpired() {
      // if (!this.selectedDeliverable || !this.selectedDeliverable.DownloadDeadline) {
      //   return false
      // }
      // const deadline = new Date(this.selectedDeliverable.DownloadDeadline)
      // const now = new Date()
      // return now > deadline
      return false
    }
  }
}
</script>
<style lang="css" scoped>
#row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.type-chip {
  font-size: 11px;
}
</style>